import React from 'react';
import TextAreaComponent from 'shared/components/TextAreaComponent';

const SpecialInstruction = (props) => {
  const name = 'special_instructions';
  const {
    parameters,
    onChangeParameter,
    groupName,
    rows,
    tooltip,
    label,
    disabled,
    errorMessage,
  } = props;

  const onChange = e => onChangeParameter(name, e.target.value);

  return (
    <TextAreaComponent
      label={label}
      name={name}
      onChange={onChange}
      value={parameters[name] || ''}
      groupName={groupName}
      rows={rows}
      tooltip={tooltip}
      disabled={disabled}
      errorMessage={errorMessage} />
  );
};

SpecialInstruction.defaultProps = {
  rows: 2,
  groupName: 'parameters',
  label: 'Special Instructions',
};

export default SpecialInstruction;
